// eslint-disable-next-line import/named
import { createConfirmCancelButtons } from './modal-footer-buttons';
import { EventSnippet, Snippet } from '../../interop/webmodule-interop';
import { html, TemplateResult } from 'lit';
import { LitBaseModal } from './modal/modal-factory-lit';
import { LangModalValidationHandler } from '../../../localization/webmodule-common/other/ui/modal-validationhandler-lang';
import { globalState } from './global-state';

export async function showValidations(items: string[], title?: EventSnippet) {
  if (!title) title = () => LangModalValidationHandler.validationReport();
  await new ValidationWithDiscardDialog(title, items).showModal();
}

export async function showValidationsWithDiscard(
  items: string[],
  title?: EventSnippet,
  buttons?: ValidationButtons
): Promise<boolean> {
  if (!title) title = () => LangModalValidationHandler.validationReport();
  if (!buttons) buttons = getValidationButtons()[ValidationButtonType.discardStay];
  const modal = new ValidationWithDiscardDialog(title, items, buttons);
  await modal.showModal();
  return modal.discard;
}

export async function showValidationsWithAbandon(
  items: string[],
  title?: EventSnippet,
  buttons?: ValidationButtons
): Promise<boolean> {
  if (!title) title = () => LangModalValidationHandler.validationReport();
  if (!buttons) buttons = getValidationButtons()[ValidationButtonType.stayAbandon];
  const modal = new ValidationWithDiscardDialog(title, items, buttons);
  await modal.showModal();
  return modal.discard;
}

export interface ValidationButtons {
  discard: string;
  stay: string;
}
export interface ValidationButtonsProvider {
  discard: () => string;
  stay: () => string;
}

function getValidationButtons(): ValidationButtons[] {
  const gs = globalState();
  gs.validationButtons ??= [
    {
      discard: () => LangModalValidationHandler.discardAndClose(),
      stay: () => LangModalValidationHandler.stayOnPage()
    },
    {
      discard: () => LangModalValidationHandler.discardChanges(),
      stay: () => LangModalValidationHandler.stayOnPage()
    }
  ];
  return gs.validationButtons.map(buttons => ({
    discard: buttons.discard(),
    stay: buttons.stay()
  })) as ValidationButtons[];
}

export enum ValidationButtonType {
  discardStay = 0,
  stayAbandon = 1
}

export class ValidationWithDiscardDialog extends LitBaseModal {
  eventTitle: EventSnippet;
  issues: string[];
  buttons?: ValidationButtons;
  public discard: boolean = false;

  constructor(title: EventSnippet, issues: string[], buttons?: ValidationButtons) {
    super();
    this.eventTitle = title;
    this.issues = issues;
    this.buttons = buttons;
  }

  protected get modalClasses(): string {
    return 'modal-dialog modal-dialog-scrollable';
  }

  protected get modalSize() {
    return 'modal-xl';
  }

  title(): Snippet {
    return this.eventTitle();
  }

  public bodyTemplate() {
    const warnings = this.issues.map(issue => html` <div class="alert alert-warning" role="alert">${issue}</div>`);
    return html`${warnings}`;
  }

  public footerTemplate(): TemplateResult | null {
    if (!this.buttons) {
      return html` <webmodule-button size="small" variant="default" @click=${() => this.hideModal()}
        >${LangModalValidationHandler.close()}
      </webmodule-button>`;
    }

    const discardEvent = () => {
      this.discard = true;
      this.hideModal();
    };

    return createConfirmCancelButtons(this.buttons.discard, discardEvent, this.buttons.stay, () => this.hideModal());
  }

  protected ZIndex(): number | undefined {
    return 99993;
  }
}
